import { tsThemeVars } from '../data';
import { GET_RELEASE_VARIABLES, RELEASE_VARIABLES_TYPE } from '../constants';
import { createMessageHandler, getHostFromUrl } from './tokenService';

const isNewVersion = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  const releaseVariablesAvailable = urlParams.get('releaseVariablesAvailable') || 'false';
  return releaseVariablesAvailable === 'true';
};

const getReleaseVariables = async (): Promise<any> => {
  try {
    if (getHostFromUrl() !== null && isNewVersion()) {
      const response = await createMessageHandler(
        RELEASE_VARIABLES_TYPE,
        10000,
        GET_RELEASE_VARIABLES
      );
      return response.data;
    }
    return { variables: tsThemeVars };
    // eslint-disable-next-line no-unreachable
  } catch (error) {
    console.error('failed to fetch variables', error);
    return { variables: tsThemeVars };
  }
};

const exportThemeToFile = (colors: any) => {
  const fileData = JSON.stringify(colors, null, 2);
  const blob = new Blob([fileData], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  const timestamp = new Date();
  link.download = `ts-vars-${timestamp.toISOString()}.json`;
  link.href = url;
  link.click();
};

const isAiMode = (): boolean => {
  // will remove this param after testing
  const urlParams = new URLSearchParams(window.location.search);
  const aiMode =
    urlParams.get('themeBuilderAiMode') || process.env.REACT_APP_IS_AI_MODE_ENABLED || 'false';
  return aiMode === 'true';
};

export { exportThemeToFile, getReleaseVariables, isNewVersion, isAiMode };
